module.exports = __webpack_public_path__ + "static/img/logo.bc5d0646.png";